import Icon from '../components/Icon.vue'

Icon.register({"hand-holding-heart":{"width":576,"height":512,"paths":[{"d":"M275.3 250.5C282.3 257.9 293.7 257.9 300.8 250.5L409.7 136.3C441.3 103.1 439.5 48.1 404.1 17.5 373.3-9.2 327.4-4.4 299.2 25.2L288 36.9 276.9 25.3C248.7-4.4 202.8-9.2 172 17.5 136.7 48.1 134.8 103.1 166.4 136.3L275.3 250.5zM565.3 328.1C553.5 317.4 535.1 318.1 522.7 328.1L430.3 402C419 411.1 404.9 416 390.3 416H272C263.2 416 256 408.8 256 400S263.2 384 272 384H350.3C366.2 384 381 373.1 383.6 357.4 386.9 337.4 371.5 320 352 320H192C165 320 138.9 329.3 117.9 346.3L71.4 384H16C7.2 384 0 391.2 0 400V496C0 504.8 7.2 512 16 512H372.8C387.3 512 401.4 507.1 412.8 498L564 377C579.2 364.9 580.4 341.7 565.3 328.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-holding-heart.js
// module id = Njux
// module chunks = 0